export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hooks.hook('schema-org:meta', (meta) => {
    const host = nuxtApp.ssrContext?.event.node.req.headers.host
    meta.host = `https://${host}/${meta.locale}`
    if (meta.path)
      meta.path = meta.path.replace(/^\/[a-z]{2}-[a-z]{2}\//g, '/')
  })
})
